import { render, staticRenderFns } from "./article_category_modal.vue?vue&type=template&id=2d5f65f5&"
import script from "./article_category_modal.vue?vue&type=script&lang=js&"
export * from "./article_category_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports